import { createApp } from 'vue'

document.addEventListener('turbo:load', () => {
  const el = document.querySelector('.vue-mobile-menu')
  if (el) {
    const app = createApp({
      data () {
        return {
          isOpen: false
        }
      }
    })
    app.mount(el)
  }
})
